<template>
  <div class="main-container">
    <div class="bread">
      <ExamIndexBread></ExamIndexBread>
      <span class="slash">/</span>
      <router-link :to="{ name: 'ExamPackage' }">套卷练习</router-link>
      <span class="slash">/</span>
      <router-link :to="{ name: 'ExamPackagePaper', query: { id: package_id } }">
        {{ package_name }}
      </router-link>
      <span class="slash">/</span>
      <span class="current">{{ detail.name }}</span>
    </div>
    <div class="main-content">
      <div class="detail-wrap">
        <div class="name bold5">{{ detail.name }}</div>
        <div class="count-wrap">
          <span class="label">试卷总分：</span>
          <span class="value">{{ detail.score }}</span>
          <span class="label">作答时长：</span>
          <span class="value">
            {{ detail.limit_time > 0 ? detail.limit_time / 60 + '分钟' : '不限制' }}
          </span>
          <span class="label">题目总数：</span>
          <span class="value">{{ detail.ques_num }}</span>
          <span class="label">练习人数：</span>
          <span class="value">{{ detail.practiceNum }}</span>
        </div>
      </div>
      <div class="js"></div>
      <div class="paper-js">
        <div class="header bold5">一、试卷结构</div>
        <div class="body body-section">
          <div class="section-sum">该试卷共由{{ detail.sectionSum }}部分组成，其中：</div>
          <div class="section" v-for="(section, index) in detail.section" :key="index">
            <div class="name">{{ index + 1 }}. {{ section.name }}</div>
            <div class="introduce">{{ section.introduce }}</div>
          </div>
        </div>
        <div class="header bold5">二、试卷简介</div>
        <div class="body body-introduce">{{ detail.introduce }}</div>
      </div>
      <router-link
        class="btn"
        :to="{
          name: 'ExamPackageDo',
          query: {
            id: report_id,
            paper_id: id,
            package_id: package_id,
            package_name: package_name,
          },
        }"
      >
        进入练习
      </router-link>
    </div>
  </div>
</template>
<script>
import ExamIndexBread from './components/ExamIndexBread.vue';

export default {
  name: 'ExamPackagePaperDetail',
  components: { ExamIndexBread },
  data() {
    return {
      id: this.$route.query.id,
      package_id: this.$route.query.package_id,
      package_name: this.$route.query.package_name,
      report_id: this.$route.query.report_id,
      detail: {},
    };
  },
  async created() {
    this.detail = await this.$http.post('/api/app/practice/exam', {
      package_id: this.package_id,
      exam_id: this.id,
      report_id: this.report_id,
    });
  },
};
</script>
<style lang="scss" scoped>
.main-content {
  background: rgba(255, 255, 255, 1);
  border-radius: 5px;
  padding: 20px 30px;
  margin-bottom: 30px;
}
.detail-wrap {
  border: 1px solid rgba(237, 237, 237, 1);
  padding: 26px;
  margin-bottom: 39px;

  .name {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    line-height: 1;
    margin-bottom: 28px;
  }
}
.count-wrap {
  font-size: 14px;
  line-height: 1;

  .label {
    color: #999999;
  }

  .value {
    color: black;

    &:nth-child(2) {
      margin-right: 160px;
    }

    &:nth-child(4) {
      margin-right: 164px;
    }

    &:nth-child(6) {
      margin-right: 183px;
    }
  }
}
.js {
  background-image: url('~@/assets/images/exam/paper-js@2x.png');
  background-size: 100% 100%;
  height: 16px;
  margin-bottom: 38px;
}
.paper-js {
  .header {
    font-size: 16px;
    font-family: PingFang SC;
    color: rgba(51, 51, 51, 1);
    line-height: 1;
  }
  .body {
    padding-left: 32px;
  }
  .section {
    overflow: hidden;
  }
  .section-sum {
    font-size: 14px;
    color: rgba(51, 51, 51, 1);
    line-height: 1;
    margin-bottom: 28px;
  }
  .name {
    font-size: 14px;
    color: rgba(0, 0, 0, 1);
    line-height: 1;
    margin-bottom: 17px;
  }
  .introduce {
    font-size: 14px;
    color: rgba(128, 128, 128, 1);
    line-height: 1;
    margin-bottom: 32px;
  }
  .body-section {
    margin-bottom: 20px;
    padding-top: 17px;
  }
  .body-introduce {
    padding: 23px 0 18px 32px;
    font-size: 14px;
    color: rgba(128, 128, 128, 1);
    line-height: 28px;
  }
}
.btn {
  display: block;
  width: 160px;
  height: 42px;
  background: $primary-color;
  border-radius: 21px;
  color: white;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 42px;
  text-align: center;
  margin: 0 auto 46px auto;
}
</style>
